import './VendorLeadBillingInfoStepper.scss';

import DocumentsStepIcon from 'src/assets/step-icon-documents.svg?react';

export function VendorLeadBillingInfoStepper() {
  return (
    <div className="vendor-lead-billing-info-stepper__container">
      <div className="vendor-lead-billing-info-stepper__step">
        <DocumentsStepIcon />
        <div className="flex column nowrap">
          <div className="vendor-lead-billing-info-stepper__step-number">Step 1</div>
          <div className="vendor-lead-billing-info-stepper__step-title">Billing Information</div>
        </div>
      </div>
    </div>
  );
}
